import React, { useState } from 'react';
import { Formik, Form, Field, ErrorMessage } from 'formik';
import * as Yup from 'yup';
import emailjs from '@emailjs/browser';
import Layout from '../components/Layout';
// import MainMenu from '../components/MainMenu.jsx';
import { Helmet } from 'react-helmet';

const Contact = () => {
  // Scroll to top when component mounts
  if (typeof window !== 'undefined') {
    window.scrollTo(0, 0);
  }

  const [submitted, setSubmitted] = useState(false);

  // Validation schema (no phone)
  const validationSchema = Yup.object({
    name: Yup.string()
      .min(2, 'Name must be at least 2 characters')
      .max(50, 'Name must be 50 characters or less')
      .required('Name is required'),
    email: Yup.string()
      .email('Invalid email address')
      .required('Email is required'),
    comment: Yup.string()
      .min(20, 'Comment must be at least 20 characters')
      .max(100, 'Comment must be 100 characters or less')
      .required('Comment is required'),
  });

  const handleSubmit = (values, { setSubmitting, resetForm }) => {
    emailjs
      .send(
        'service_b02rpyg',        
        'template_1ch4w38',       
        {
          name: values.name,
          email: values.email,
          message: values.comment,         
          title: 'New website enquiry',   
        },
        '7EV4KkAPoc4xz05hg'     
      )
      .then(
        () => {
          resetForm();
          setSubmitted(true); 
          setSubmitting(false);
        },
        (error) => {
          console.error('Email send error:', error);
          alert('Sorry, something went wrong sending your message.');
          setSubmitting(false);
        }
      );
  };

  return (
    <Layout>
      <Helmet>
        <title>Contact – This Belongs To</title>
        <meta
          name="description"
          content="Contact This Belongs To for enquiries, orders, collaborations, and customer support."
        />
        <link
          rel="canonical"
          href="https://this-belongs-to.vercel.app/pages/contact"
        />
      </Helmet>
      {/* <MainMenu /> */}
      <div className="flex flex-col items-center justify-center w-full p-4 mt-10">
        <h1 className="text-3xl italic mb-4">Contact Us</h1>

        {submitted ? (
          <p className="mt-8 text-center text-customNavy italic text-lg max-w-2xl">
            Thank you for your message – we&rsquo;ll be in touch soon!
          </p>
        ) : (
          <Formik
            initialValues={{ name: '', email: '', comment: '' }}
            validationSchema={validationSchema}
            onSubmit={handleSubmit}
          >
            {({ isSubmitting }) => (
              <Form className="w-full max-w-3xl mt-8">
                {/* Name + Email row */}
                <div className="flex flex-wrap -mx-3 mb-6">
                  <div className="w-full md:w-1/2 px-3 mb-6 md:mb-0">
                    <Field
                      name="name"
                      type="text"
                      placeholder="Name"
                      className="appearance-none block w-full bg-white text-customNavy border border-customNavy py-3 px-4 leading-tight focus:outline-none focus:bg-white"
                    />
                    <ErrorMessage
                      name="name"
                      component="div"
                      className="text-red-500 text-sm mt-1"
                    />
                  </div>
                  <div className="w-full md:w-1/2 px-3">
                    <Field
                      name="email"
                      type="email"
                      placeholder="Email"
                      className="appearance-none block w-full bg-white text-customNavy border border-customNavy py-3 px-4 leading-tight focus:outline-none focus:bg-white"
                    />
                    <ErrorMessage
                      name="email"
                      component="div"
                      className="text-red-500 text-sm mt-1"
                    />
                  </div>
                </div>

                {/* Comment textarea */}
                <div className="flex flex-wrap -mx-3 mb-6">
                  <div className="w-full px-3">
                    <Field
                      name="comment"
                      as="textarea"
                      placeholder="Comment"
                      rows="5"
                      className="appearance-none block w-full bg-white text-customNavy border border-customNavy py-3 px-4 leading-tight focus:outline-none focus:bg-white"
                    />
                    <ErrorMessage
                      name="comment"
                      component="div"
                      className="text-red-500 text-sm mt-1"
                    />
                  </div>
                </div>

                {/* Submit button */}
                <div className="flex items-center justify-center w-full">
                  <button
                    type="submit"
                    disabled={isSubmitting}
                    className="w-full bg-customNavy hover:bg-white hover:border-customNavy hover:text-customNavy text-white font-bold py-3 px-8 border-transparent border-2 focus:outline-none focus:shadow-outline transition-colors duration-300"
                  >
                    {isSubmitting ? 'Sending…' : 'Submit'}
                  </button>
                </div>
              </Form>
            )}
          </Formik>
        )}
      </div>
    </Layout>
  );
};

export default Contact;
